export default __webpack_public_path__ + "static/media/logo-algostudy-n@2x.be6d1cc2.webp";